import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import { getBrighterColor } from "../../utils/functions";
export var NotificationBannerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  display: flex;\n  gap: ", ";\n  align-items: flex-start;\n  transition: all 0.3s;\n\n  color: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  svg {\n    flex-shrink: 0;\n    fill: ", ";\n    font-size: 24px;\n  }\n\n  .close-icon {\n    cursor: pointer;\n    fill: ", ";\n  }\n\n  transform-origin: top;\n  ", "\n"], ["\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  display: flex;\n  gap: ", ";\n  align-items: flex-start;\n  transition: all 0.3s;\n\n  color: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  svg {\n    flex-shrink: 0;\n    fill: ", ";\n    font-size: 24px;\n  }\n\n  .close-icon {\n    cursor: pointer;\n    fill: ", ";\n  }\n\n  transform-origin: top;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.m;
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return getBrighterColor(theme.colors[color].lightest, 60);
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return theme.colors[color].lighter;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return theme.colors[color].default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return $isOpen
        ? "pointer-events: auto; transform: scaleY(1);"
        : " pointer-events: none; transform: scaleY(0);";
});
export var ContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map